import { PkDialog, PkDivider, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

type DemandDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

const DemandDialog = ({ isOpen, onClose }: DemandDialogProps) => {
  const t = useTranslateFn();

  return (
    <PkDialog className={styles.dialog} isOpen={isOpen} onPkClose={onClose}>
      <div slot='body'>
        <div className='pk-font-size--l pk-font--comp-bold pk-text--text-01 pk-pr--xl pk-pt--xs'>
          {t('ticket_demand')}
        </div>
        <div className='pk-mt--l pk-mb--l pk-line-height--md'>{t('ticket_demand_description')}</div>
        <div className={styles.info}>
          <div className={clsx(styles.higherDemand, styles.infoDetail)}>{t('higher_demand')}</div>
          <div>
            <PkIcon name='navigation-back-android' />
          </div>
          <div className={clsx(styles.lowerChance, styles.infoDetail)}>
            <div>
              <PkIcon name='navigation-dropdown-up' color='support-04' />
              {t('lower_chance')}
            </div>
          </div>
        </div>
        <PkDivider className='pk-mt--m pk-mb--m' />
        <div className={styles.info}>
          <div className={clsx(styles.lowerDemand, styles.infoDetail)}>{t('lower_demand')}</div>
          <div>
            <PkIcon name='navigation-back-android' />
          </div>
          <div className={clsx(styles.higherChance, styles.infoDetail)}>
            <div>
              <PkIcon name='navigation-dropdown-indicator' color='support-01' />
              {t('higher_chance')}
            </div>
          </div>
        </div>
      </div>
    </PkDialog>
  );
};

export default memo(DemandDialog);
